import { createBeanDecorator } from 'zova';
export function Css(options) {
  return createBeanDecorator('css', 'app', true, options);
}
export function Theme(options) {
  return createBeanDecorator('theme', 'app', true, options);
}